import { Notification } from '@missionlabs/react'
import { UserActivity } from '@missionlabs/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { NotificationProps } from 'shared/components/Notifications/types'
import { useActivityInfo } from 'shared/hooks/useActivityInfo'

export const SMSNotification: FC<NotificationProps<UserActivity>> = ({
    item: activity,
    navigate,
    onClose
}) => {
    const { t } = useTranslation()
    const { name, company, team } = useActivityInfo(activity)

    const onDismiss = () => {
        if (!activity) return
        onClose(activity.ID)
    }

    const onMessage = () => {
        if (!activity) return
        navigate({ pathname: `/home/feed` }, { state: { activityID: activity.ID } })
        onClose(activity.ID)
    }

    if (!activity) return null

    return (
        <Notification
            variant="sms"
            header={t('notifications.sms')}
            name={name}
            role={company}
            via={team}
            onMessage={onMessage}
            onDismiss={onDismiss}
        />
    )
}
